import React from "react";
import Card   from "react-bootstrap/Card";
import Button from 'react-bootstrap/Button';

function AboutCard() {

  const handleResumeClick = () => {
    const resumeUrl = '/Altaf_Ali_Baig_Resume.pdf';
  
    // Open in a new tab
    window.open(resumeUrl, '_blank', 'noopener,noreferrer');
  
    // Trigger download
    const link = document.createElement('a');
    link.href = resumeUrl;
    link.download = 'Altaf_Resume.pdf'; // 👈 you can name it anything
    link.click();
  };
  

  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify",color:"white" }}>
            Hi Everyone, I am <span className="purple">Altaf Ali Baig </span>
            from <span className="purple"> Bhopal, India.</span>
            <br />
            Aspiring Full Stack Developer.
           
            Capable of writing production-ready code using
            React-JS, Redux, and CSS on the frontend ,Node-JS and Express on the
            backend to build single page applications. Collaborative, team player who is
            proficient in working with interdisciplinary teams and executing goal oriented
            projects. Passionate about coding and strongly interested in working in a
            product based company

            
          </p>
          
        </blockquote>
      </Card.Body>
      {/* "https://drive.google.com/file/d/1Gm3XYaJSj7WezRVFpR3ESXLHKrDi4TvX/view" */}

    
      <Button    onClick={handleResumeClick} variant="outline-primary" size="lg"style={{fontWeigth:"900",width:"60%",margin:"auto"}} >Resume</Button>
    </Card>
  );
}

export default AboutCard;
